"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminInviteUserToCommunityPoolRequestBodyToJSON = exports.AdminInviteUserToCommunityPoolRequestBodyFromJSONTyped = exports.AdminInviteUserToCommunityPoolRequestBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function AdminInviteUserToCommunityPoolRequestBodyFromJSON(json) {
    return AdminInviteUserToCommunityPoolRequestBodyFromJSONTyped(json, false);
}
exports.AdminInviteUserToCommunityPoolRequestBodyFromJSON = AdminInviteUserToCommunityPoolRequestBodyFromJSON;
function AdminInviteUserToCommunityPoolRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'adminNotes': !(0, runtime_1.exists)(json, 'adminNotes') ? undefined : json['adminNotes'],
    };
}
exports.AdminInviteUserToCommunityPoolRequestBodyFromJSONTyped = AdminInviteUserToCommunityPoolRequestBodyFromJSONTyped;
function AdminInviteUserToCommunityPoolRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'adminNotes': value.adminNotes,
    };
}
exports.AdminInviteUserToCommunityPoolRequestBodyToJSON = AdminInviteUserToCommunityPoolRequestBodyToJSON;
